import { useNavigate } from 'react-router-dom';
import i18n from '@/localisation/i18n';
import { removeCookies } from '@/utils/cookie';

export const LogoutButton = () => {
  const navigate = useNavigate();

  return (
    <button
      onClick={() => {
        removeCookies('auth');
        navigate(0);
      }}
      className="btn btn-outline mb-10 mt-auto w-full"
    >
      {i18n.t('logout')}{' '}
      <svg
        width="17"
        height="16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.5 2.5a1 1 0 0 0-1 1v9a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1V10a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2v-9a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2V6a.5.5 0 0 1-1 0V3.5a1 1 0 0 0-1-1h-4Zm7.146 3.146a.5.5 0 0 1 .708 0l2 2a.5.5 0 0 1 0 .708l-2 2a.5.5 0 0 1-.708-.708L13.793 8.5H6.5a.5.5 0 0 1 0-1h7.293l-1.147-1.146a.5.5 0 0 1 0-.708Z"
          fill="currentColor"
        />
      </svg>
    </button>
  );
};
